import { gql } from '@apollo/client';
import { loader } from 'graphql.macro';

const FRAGMENT = loader('./visibilityFragment.gql');

export const VISIBILITY_TYPE_NAME = 'Visibility';
export const VISIBILITY_FRAGMENT_NAME = 'VisibilityFragment';
export const VISIBILITY_FRAGMENT = gql`
    ${FRAGMENT}
`;
